module.exports = __webpack_public_path__ + "static/media/banner_phone_1.a3118f87.png";